module.exports = __webpack_public_path__ + "fonts/iconfont.52e30b67.woff";